<template>
  <div class="tips-container">
    <div class="item">
      <!--   <img class="item-title"
                src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/4036bc64fa622ab2a39e26164c544fe9.png" alt=""> -->
      <div>
        <img
          class="item-image"
          src="https://btw-common-data.betterwestar.com/btw-admin/admin-common-data/2025-12/6c7d84f2585b74161372702a39f50bd0_wh=1041_816.webp"
          alt=""
        />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  components: {},
  data() {
    return {}
  },
  created() {},
  methods: {
    bindClick() {
      this.$betterwe.vipHomePage()
    }
  }
}
</script>
<style lang="scss" scoped>
.item {
  position: relative;
  padding: 0px 14px 10px;
  margin-bottom: 10px;

  .item-title {
    position: absolute;
    left: 50%;
    top: -20px;
    width: 252px;
    height: 68px;
    transform: translate(-50%, -63%);
  }

  .item-image {
    width: 100%;
  }
}
</style>
